import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectDoctorState } from '../../../store/app.states';
import { Observable } from 'rxjs';
import { Patient } from '../../../model/user/Patient';
import { MatDialog } from '@angular/material/dialog';
import {
  IBDDiskResults,
} from '../../../model/questionnaires/questionnaire-ibddisk';
import { BaseChartDirective, Label } from 'ng2-charts';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { HBIResults } from '../../../model/questionnaires/questionnaire-hbi';
import {
  GetQuestionnairesClinicalHBI, GetQuestionnairesClinicalPRISM,
  GetQuestionnairesClinicalSCCAI,
  GetQuestionnairesEORTC,
  GetQuestionnairesEQ5D5L,
  GetQuestionnairesHADS,
  GetQuestionnairesHBI,
  GetQuestionnairesIBDDisk,
  GetQuestionnairesIPAQSF, GetQuestionnairesMIAHCD, GetQuestionnairesMIAHUC, GetQuestionnairesMMAS8,
  GetQuestionnairesPatientSCCAI, GetQuestionnairesPHQ9, GetQuestionnairesPRISM, GetQuestionnairesPSQI,
  GetQuestionnairesSIBDQ,
  GetQuestionnairesLARS,
  GetQuestionnairesTSQM,
  GetQuestionnairesWPAI,
  GetQuestionnairesIBDQ
} from '../../../store/actions/doctor.actions';
import { DialogService } from '../../../services/dialog.service';
import * as _moment from 'moment';
// @ts-ignore
import { default as _rollupMoment } from 'moment';
import { SIBDQResults } from '../../../model/questionnaires/questionnaire-sibdq';
import { BackendApi, localhost } from '../../../config/backend-api';
import { HttpClient } from '@angular/common/http';
import { HADSResults } from '../../../model/questionnaires/questionnaire-hads';
import { MIAHCDResults } from '../../../model/questionnaires/questionnaire-miah-cd';
import { MIAHUCResults } from '../../../model/questionnaires/questionnaire-miah-uc';
import { MMAS8Results } from '../../../model/questionnaires/questionnaire-mmas8';
import { PatientSccaiResults } from '../../../model/questionnaires/questionnaire-patient-sccai';
import { PHQ9Results } from '../../../model/questionnaires/questionnaire-phq9';
import { ClinicalSccaiResults } from '../../../model/questionnaires/questionnaire-clinical-sccai';
import { MatTableDataSource } from '@angular/material/table';
import { EvaluationDTO } from '../../../services/dialogs/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DoctorService } from '../../../services/doctor.service';
import { IBDQResults } from '../../../model/questionnaires/questionnaire-ibdq';
import { LARSResults, Q_LARS } from '../../../model/questionnaires/questionnaire-lars';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-patient-questionnaires-show',
  templateUrl: './patient-questionnaires-show.component.html',
  styleUrls: ['./patient-questionnaires-show.component.css']
})
export class PatientQuestionnairesShowComponent implements OnInit, OnDestroy {

  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  patient: Patient;
  title: string;
  destination: string;

  hide = true;

  patientSSN: string;
  type: string;

  // CONFIG
  toShow = null;
  selected = [];

  // valore per attività di malattia
  diseaseActivity = null;

  // COMMON CONFIG GRAPH
  public lineChartType: ChartType = 'line';
  public lineChartData: ChartDataSets[] = [];
  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions = {};

  @ViewChild('baseChart') baseChart: BaseChartDirective;
  read = false;
  notRead = false;
  warned = false;
  evaluated = false;
  displayedColumns: string[] = ['results'];
  dataSource: MatTableDataSource<any>;
  selection = false;
  allCheck = [];
  doctor = '';

  constructor(private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private dialogService: DialogService,
    private httpClient: HttpClient,
    private snackBar: MatSnackBar,
    private doctorService: DoctorService) {

    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
    this.route.params.subscribe(params => {
      this.patientSSN = params.ssn;
      this.type = params.type;
      this.destination = '/patient-questionnaire-panel/' + this.patientSSN;
      if (params.back.localeCompare('global') === 0) {
        this.destination = 'patient-questionnaire-panel/' + this.patientSSN + '/global';
      } else if (params.back.localeCompare('general-status') === 0) {
        this.destination = 'general-status';
      } else {
        this.destination = 'patient-questionnaire-panel/' + this.patientSSN + '/local';
      }
      this.title = this.type.toUpperCase();
    });

    document.addEventListener('notification', () => {
      this.dispatching(this.type, this.patientSSN);
      setTimeout(() => {
        this.toShow = JSON.parse(localStorage.getItem(this.type));
        console.log(this.toShow);
        if (this.toShow !== null) {
          this.toShow.sort((r1, r2) => this.comparing(r1, r2));
          this.toShow.forEach(ts => this.allCheck.push(false));
          this.dataSource = new MatTableDataSource(this.toShow);
        }
      }, 2000);
      setTimeout(() => {
        this.reloadChart();
      }, 1000);
    });

  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });

    this.setupPatient();
    setTimeout(() => {
      this.setup();
    }, 500);
  }

  setupPatient() {
    const patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
    this.patient = patients.find(p => p.ssn.localeCompare(this.patientSSN) === 0);
    this.dispatching(this.type, this.patientSSN);
  }

  setupDoctorInfo() {
    this.toShow.forEach(q => {
      console.log(q.doctorID);
      this.doctorService.getDoctorInfo(q.doctorID).subscribe(response => {
        sessionStorage.setItem(q.doctorID, JSON.stringify(response));
      });
    });
  }

  reloadChart() {
    console.log('reloading chart');
    if (this.baseChart !== undefined) {
      this.baseChart.chart = null;

      const newShow = JSON.parse(localStorage.getItem(this.type.toLowerCase()));
      console.log(newShow);

      const labels: string[] = [];
      newShow.sort((r1, r2) => this.comparing(r1, r2));
      newShow.slice().reverse().forEach((r, i) => labels[i] = r.id.split('-')[0]);


      let total = [];

      switch (this.type.toUpperCase()) {
        /*case 'CLINICAL-SCCAI':
          total = this.calculateTotalClinicalSCCAIResults(newShow);
          break;*/
        case 'HADS':
          total = this.calculateTotalHADSResults(newShow);
          break;
        case 'HBI':
          total = this.calculateTotalHBIResults(newShow);
          break;
        case 'IBD-DISK':
          total = this.calculateTotalIBDDiskResults(newShow);
          break;
        case 'MIAH-CD':
          total = this.calculateTotalMIAHCDResults(newShow);
          break;
        case 'MIAH-UC':
          total = this.calculateTotalMIAHUCResults(newShow);
          break;
        case 'MMAS8':
          total = this.calculateTotalMMAS8Results(newShow);
          break;
        case 'PATIENT-SCCAI':
          total = this.calculateTotalPatientSCCAIResults(newShow);
          break;
        case 'PHQ9':
          total = this.calculateTotalPHQ9Results(newShow);
          break;
        case 'SIBDQ':
          total = this.calculateTotalSIBDQResults(newShow);
          break;
        case 'IBDQ':
          total = this.calculateTotalSIBDQResults(newShow);
          break;
        case 'LARS':
          total = this.calculateTotalLARSResults(newShow);
          break;
      }

      this.lineChartLabels = labels;

      this.lineChartData[0] = Object.assign({}, this.lineChartData[0], {
        data: total,
      });

      this.baseChart.datasets = this.lineChartData;
      this.baseChart.options = this.lineChartOptions;
      this.baseChart.labels = this.lineChartLabels;
      this.baseChart.ngOnInit();
    }
  }

  setup() {
    const patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
    this.patient = patients.find(p => p.ssn.localeCompare(this.patientSSN) === 0);

    if (this.toShow === null || this.toShow === undefined) {
      this.toShow = JSON.parse(localStorage.getItem(this.type.toLowerCase()));
      if (this.toShow !== null) {

        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
        this.toShow.forEach(ts => this.allCheck.push(false));
        this.dataSource = new MatTableDataSource(this.toShow);

        const labels: string[] = [];
        this.toShow.slice().reverse().forEach((r, i) => labels[i] = r.id.split('-')[0]);

        switch (this.type.toUpperCase()) {
          /*case 'CLINICAL-SCCAI':
            const totalClinicalSCCAIResults = this.calculateTotalClinicalSCCAIResults(this.toShow);
            this.lineChartData.push({
              data: totalClinicalSCCAIResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 20,
                    min: 0,
                    stepSize: 5
                  }
                }]
              }
            };
            break;*/
          case 'HADS':
            const totalHADSResults = this.calculateTotalHADSResults(this.toShow);
            this.lineChartData.push({
              data: totalHADSResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 42,
                    min: 0,
                    stepSize: 6
                  }
                }]
              }
            };
            break;

          case 'HBI':
            const totalHBIResults = this.calculateTotalHBIResults(this.toShow);
            this.lineChartData.push({
              data: totalHBIResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 45,
                    min: 0,
                    stepSize: 15
                  }
                }]
              }
            };
            break;

          case 'IBD-DISK':
            const totalIBDDiskResults = this.calculateTotalIBDDiskResults(this.toShow);
            this.lineChartData.push({
              data: totalIBDDiskResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 100,
                    min: 0,
                    stepSize: 20
                  }
                }]
              }
            };
            break;

          case 'MIAH-CD':
            const totalMIAHCDResults = this.calculateTotalMIAHCDResults(this.toShow);
            this.lineChartData.push({
              data: totalMIAHCDResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 100,
                    min: 0,
                    stepSize: 25
                  }
                }]
              }
            };
            break;

          case 'MIAH-UC':
            const totalMIAHUCResults = this.calculateTotalMIAHUCResults(this.toShow);
            this.lineChartData.push({
              data: totalMIAHUCResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 100,
                    min: 0,
                    stepSize: 25
                  }
                }]
              }
            };
            break;

          case 'MMAS8':
            const totalMMAS8Results = this.calculateTotalMMAS8Results(this.toShow);
            this.lineChartData.push({
              data: totalMMAS8Results
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 11,
                    min: 0,
                    stepSize: 2
                  }
                }]
              }
            };
            break;

          case 'PATIENT-SCCAI':
            const totalPatientSCCAIResults = this.calculateTotalPatientSCCAIResults(this.toShow);
            this.lineChartData.push({
              data: totalPatientSCCAIResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 21,
                    min: 0,
                    stepSize: 3
                  }
                }]
              }
            };
            break;

          case 'PHQ9':
            const totalPHQ9Results = this.calculateTotalPHQ9Results(this.toShow);
            this.lineChartData.push({
              data: totalPHQ9Results
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 27,
                    min: 0,
                    stepSize: 3
                  }
                }]
              }
            };
            break;

          case 'SIBDQ':
            const totalSIBDQResults = this.calculateTotalSIBDQResults(this.toShow);
            this.lineChartData.push({
              data: totalSIBDQResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 70,
                    min: 0,
                    stepSize: 10
                  }
                }]
              }
            };
            break;
          case 'IBDQ':
            const totalIBDQResults = this.calculateTotalIBDQResults(this.toShow);
            this.lineChartData.push({
              data: totalIBDQResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 224,
                    min: 0,
                    stepSize: 10
                  }
                }]
              }
            };
            break;

          case 'LARS':
            const totalLARSResults = this.calculateTotalLARSResults(this.toShow);
            this.lineChartData.push({
              data: totalLARSResults
            });
            this.lineChartLabels = labels;
            this.lineChartOptions = {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  ticks: {
                    max: 224,
                    min: 0,
                    stepSize: 10
                  }
                }]
              }
            };
            break;

        }
        this.setupDoctorInfo();
      }
    }
  }


  calculateTotalClinicalSCCAIResults(toShow: ClinicalSccaiResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
      console.log(result.finalScore);
    });

    if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }

    return total;
  }

  calculateTotalHADSResults(toShow: HADSResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
      console.log(result.finalScore);
    });

    if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }

    return total;
  }

  calculateTotalHBIResults(toShow: HBIResults[]) {

    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
    });

    /*if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }*/
    if (total.length >= 2) {
      console.log(total);
      if (total[total.length - 1] <= (total[total.length - 2] - 2)) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] >= (total[total.length - 2] + 2)) {
        this.diseaseActivity = 'in peggioramento';
      } else {
        this.diseaseActivity = 'nessuna variazione';
      }
    }

    return total;
  }

  calculateTotalIBDDiskResults(toShow: IBDDiskResults[]) {

    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      result.results.forEach((r) => {
        total[index] += r;
      });
    });

    return total;
  }

  calculateTotalMIAHCDResults(toShow: MIAHCDResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
    });

    if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }

    return total;
  }

  calculateTotalMIAHUCResults(toShow: MIAHUCResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
    });

    if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }

    return total;
  }

  calculateTotalMMAS8Results(toShow: MMAS8Results[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
    });

    if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }

    return total;
  }

  calculateTotalPatientSCCAIResults(toShow: PatientSccaiResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
    });

    if (total.length >= 2) {
      console.log(total);
      if (total[total.length - 1] <= (total[total.length - 2] - 2)) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] >= (total[total.length - 2] + 2)) {
        this.diseaseActivity = 'in peggioramento';
      } else {
        this.diseaseActivity = 'nessuna variazione';
      }
    }

    return total;
  }

  calculateTotalPHQ9Results(toShow: PHQ9Results[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      total[index] = result.finalScore;
    });

    if (total.length >= 2) {
      if (total[total.length - 1] < total[total.length - 2]) {
        this.diseaseActivity = 'in miglioramento';
      } else if (total[total.length - 1] === total[total.length - 2]) {
        this.diseaseActivity = 'nessuna variazione';
      } else {
        this.diseaseActivity = 'in peggioramento';
      }
    }

    return total;
  }

  calculateTotalSIBDQResults(toShow: SIBDQResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      result.results.forEach((r) => {
        const n = parseInt(r.split(' ')[0], 10);
        total[index] += n;
      });
    });

    return total;
  }

  calculateTotalIBDQResults(toShow: IBDQResults[]) {
    const total = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    toShow.slice().reverse().forEach((result, index) => {
      result.results.forEach((r) => {
        const n = parseInt(r.split(' ')[0], 10);
        total[index] += n;
      });
    });

    return total;
  }

  calculateTotalLARSResults(toShow: LARSResults[]) {
    const total = [];

    for (let i = 0; i < toShow.length; ++i) {
      total.push(0);
    }

    const source = Q_LARS;
    toShow.slice().reverse().forEach((result, index) => {
      result.results.forEach((r, resIndex) => {
        let selectedInd = r.split('-')[0];
        let question = source[resIndex];
        console.log(' question', question);
        if (question) {
          let score: number = question.scores[parseInt(selectedInd) - 1];
          console.log('score of question', score);
          total[index] += score;
        }

      });
    });
    console.log('total --> ', total);
    return total;
  }


  dispatching(type, patientSSN) {
    const q = type.toLowerCase();
    switch (q) {
      case 'clinical-sccai':
        this.store.dispatch(new GetQuestionnairesClinicalSCCAI(patientSSN));
        break;
      case 'clinical-hbi':
        this.store.dispatch(new GetQuestionnairesClinicalHBI(patientSSN));
        break;
      case 'clinical-prism':
        this.store.dispatch(new GetQuestionnairesClinicalPRISM(patientSSN));
        break;
      case 'eortc-qlq':
        this.store.dispatch(new GetQuestionnairesEORTC(patientSSN));
        break;
      case 'eq5d5l':
        this.store.dispatch(new GetQuestionnairesEQ5D5L(patientSSN));
        break;
      case 'hads':
        this.store.dispatch(new GetQuestionnairesHADS(patientSSN));
        break;
      case 'hbi':
        this.store.dispatch(new GetQuestionnairesHBI(patientSSN));
        break;
      case 'ibd-disk':
        this.store.dispatch(new GetQuestionnairesIBDDisk(patientSSN));
        break;
      case 'ipaq-sf':
        this.store.dispatch(new GetQuestionnairesIPAQSF(patientSSN));
        break;
      case 'miah-cd':
        this.store.dispatch(new GetQuestionnairesMIAHCD(patientSSN));
        break;
      case 'miah-uc':
        this.store.dispatch(new GetQuestionnairesMIAHUC(patientSSN));
        break;
      case 'mmas8':
        this.store.dispatch(new GetQuestionnairesMMAS8(patientSSN));
        break;
      case 'patient-sccai':
        this.store.dispatch(new GetQuestionnairesPatientSCCAI(patientSSN));
        break;
      case 'phq9':
        this.store.dispatch(new GetQuestionnairesPHQ9(patientSSN));
        break;
      case 'prism':
        this.store.dispatch(new GetQuestionnairesPRISM(patientSSN));
        break;
      case 'psqi':
        this.store.dispatch(new GetQuestionnairesPSQI(patientSSN));
        break;
      case 'sibdq':
        this.store.dispatch(new GetQuestionnairesSIBDQ(patientSSN));
        break;
      case 'tsqm':
        this.store.dispatch(new GetQuestionnairesTSQM(patientSSN));
        break;
      case 'wpai':
        this.store.dispatch(new GetQuestionnairesWPAI(patientSSN));
        break;
      case 'ibdq':
        this.store.dispatch(new GetQuestionnairesIBDQ(patientSSN));
        break;
      case 'lars':
        this.store.dispatch(new GetQuestionnairesLARS(patientSSN));
        break;
    }
  }

  comparing(r1, r2) {
    const first = r1.id.split(' ');
    const second = r2.id.split(' ');
    const d1 = moment(first[0], 'DD/MM/YYYY').toDate().getTime();
    const d2 = moment(second[0], 'DD/MM/YYYY').toDate().getTime();
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }

  goTo(r) {
    switch (this.type) {
      case 'clinical-sccai':
        this.setRead(r);
        this.dialogService.openClinicalSCCAIDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'clinical-hbi':
        this.setRead(r);
        this.dialogService.openHBIDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'clinical-prism':
        this.setRead(r);
        this.dialogService.openPRISMDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'eortc-qlq':
        this.setRead(r);
        this.dialogService.openEORTCDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'eq5d5l':
        this.setRead(r);
        this.dialogService.openEQ5D5LDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'hads':
        this.setRead(r);
        this.dialogService.openHADSDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'hbi':
        this.setRead(r);
        this.dialogService.openHBIDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'ibd-disk':
        this.setRead(r);
        this.dialogService.openIBDDiskDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'ipaq-sf':
        this.setRead(r);
        this.dialogService.openIPAQSFDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'miah-cd':
        this.setRead(r);
        this.dialogService.openMIAHCDDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'miah-uc':
        this.setRead(r);
        this.dialogService.openMIAHUCDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'mmas8':
        this.setRead(r);
        this.dialogService.openMMAS8Dialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'patient-sccai':
        this.setRead(r);
        this.dialogService.openPatientSCCAIDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'phq9':
        this.setRead(r);
        this.dialogService.openPHQ9Dialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'prism':
        this.setRead(r);
        this.dialogService.openPRISMDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'psqi':
        this.setRead(r);
        this.dialogService.openPSQIDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'sibdq':
        this.setRead(r);
        this.dialogService.openSIBDQDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'ibdq':
        this.setRead(r);
        this.dialogService.openIBDQDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'lars':
        this.setRead(r);
        this.dialogService.openLARSDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'tsqm':
        this.setRead(r);
        this.dialogService.openTSQMDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      case 'wpai':
        this.setRead(r);
        this.dialogService.openWPAIDialog(r, this.user.role, this.patient).afterClosed()
          .subscribe(action => {
            setTimeout(() => {
              this.toShow = JSON.parse(localStorage.getItem(this.type));
              if (this.toShow !== null) {
                this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                this.dataSource = new MatTableDataSource(this.toShow);
              }
            }, 500);
          });
        break;
      default:
        break;
    }
  }

  setRead(r) {
    const date = r.id.split('-')[0];
    if (!r.read) {
      // tslint:disable-next-line:max-line-length
      return this.httpClient.post(localhost + BackendApi.READ_QUESTIONNAIRE + r.type + '/' + r.doctorID + '/' + r.patientSSN, date, {
        observe: 'response',
        responseType: 'text'
      }).subscribe(action => {
        console.log('letto', action);
      });
    }
  }

  showHideGraph() {
    this.hide = this.hide !== true;
  }

  filter() {
    this.read = this.read !== false;
    this.notRead = this.notRead !== false;
    this.warned = this.warned !== false;
    this.evaluated = this.evaluated !== false;

    console.log('read, notRead, warned, evaluated', this.read, this.notRead, this.warned, this.evaluated);

    if (this.read) {  // READ
      if (this.notRead) { // READ AND NOT READ
        const readAndNotRead = this.toShow.slice().filter(r => r.read || !r.read);
        this.dataSource = new MatTableDataSource(readAndNotRead);
        if (this.warned) {  // READ AND NOT READ AND WARNED
          if (this.evaluated) { // READ AND NOT READ AND WARNED AND EVALUATED
            const all = readAndNotRead.slice()/*.filter(r => r.warning || r.evaluation)*/;
            this.dataSource = new MatTableDataSource(all);
          } else {  // WARNED AND NOT EVALUATED
            const readAndNotReadAndWarned = readAndNotRead.filter(r => r.read || !r.read || r.warning);
            this.dataSource = new MatTableDataSource(readAndNotReadAndWarned);
          }
        } else {
          if (this.evaluated) { // READ AND NOT READ AND NOT WARNED AND EVALUATED
            const all = readAndNotRead.slice().filter(r => r.read || !r.read || r.evaluation);
            this.dataSource = new MatTableDataSource(all);
          }
        }
      } else {  // ONLY READ
        const onlyRead = this.toShow.slice().filter(r => r.read);
        this.dataSource = new MatTableDataSource(onlyRead);

        if (this.warned) {  // ONLY READ AND WARNED
          if (this.evaluated) { // ONLY READ AND WARNED AND EVALUATED

            const all = onlyRead.slice()/*.filter(r => r.warning || r.evaluation)*/;
            this.dataSource = new MatTableDataSource(all);

          } else {  // ONLY READ AND WARNED

            const readAndWarned = onlyRead.filter(r => r.read || r.warning);
            this.dataSource = new MatTableDataSource(readAndWarned);

          }
        } else {  // ONLY READ AND NOT WARNED
          if (this.evaluated) { // ONLY READ AND NOT WARNED AND EVALUATED

            const readAndEval = onlyRead.slice().filter(r => r.read || r.evaluation);
            this.dataSource = new MatTableDataSource(readAndEval);

          }
        }
      }
    } else {
      if (this.notRead) { // NOT READ

        const notRead = this.toShow.slice().filter(r => !r.read);
        this.dataSource = new MatTableDataSource(notRead);

        if (this.warned) {  // NOT READ AND WARNED
          if (this.evaluated) { // NOT READ AND WARNED AND EVALUATED
            const w = this.toShow.slice().filter(r => r.warning);
            const e = this.toShow.slice().filter(ev => ev.evaluation);
            notRead.push(...w);
            notRead.push(...e);
            this.dataSource = new MatTableDataSource(notRead.sort((a1, a2) => this.comparing(a1, a2)));
          } else {  // NOT READ AND WARNED

            const w = this.toShow.slice().filter(r => r.warning);
            notRead.push(...w);
            this.dataSource = new MatTableDataSource(notRead.slice().sort((a1, a2) => this.comparing(a1, a2)));

          }
        } else {  // NOT READ AND NOT WARNED
          if (this.evaluated) { // NOT READ AND NOT WARNED AND EVALUATED

            const e = this.toShow.slice().filter(ev => ev.evaluation);
            notRead.push(...e);
            this.dataSource = new MatTableDataSource(notRead.slice().sort((a1, a2) => this.comparing(a1, a2)));


          }
        }
      } else {  // ALL THE OTHER
        const all = this.toShow;
        if (this.warned) {  // ALL AND WARNED
          if (this.evaluated) { // ALL AND WARNED AND EVALUATED
            const warnedAndEvaluated = all.slice().filter(r => r.warning || r.evaluation);
            this.dataSource = new MatTableDataSource(warnedAndEvaluated);
          } else {  // ALL AND WARNED
            const warned = all.filter(r => r.warning);
            this.dataSource = new MatTableDataSource(warned);
          }
        } else {  // ALL AND NOT WARNED
          if (this.evaluated) { // ALL AND EVALUATED
            const evaluated = all.slice().filter(r => r.evaluation);
            this.dataSource = new MatTableDataSource(evaluated);
          } else {
            this.dataSource = new MatTableDataSource(this.toShow);
          }
        }
      }

    }
  }

  selectionMode() {
    this.selection = !this.selection;
  }

  selectItem(result, i) {
    if (this.selected.find(s => s === result)) {
      this.selected.forEach((s, index) => {
        if (s === result) {
          this.selected.splice(index, 1);
          this.allCheck[i] = false;
        }
      });
    } else {
      this.selected.push(result);
      this.allCheck[i] = true;
    }
    console.log('sel/unsel: ', result);
    console.log('array: ', this.selected);
    console.log('checky', this.allCheck);
  }

  selectAll() {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...this.toShow);
    for (let i = 0; i < this.allCheck.length; i++) {
      console.log('era: ', this.allCheck[i]);
      this.allCheck[i] = true;
      console.log('diventa: ', this.allCheck[i]);
    }
    console.log('array: ', this.selected);
    console.log('check', this.allCheck);
  }

  deselectAll() {
    this.selected.splice(0, this.selected.length);
    for (let i = 0; i < this.allCheck.length; i++) {
      console.log('era: ', this.allCheck[i]);
      this.allCheck[i] = false;
      console.log('diventa: ', this.allCheck[i]);
    }
    console.log('array: ', this.selected);
    console.log('checky', this.allCheck);
  }

  evaluationSelected() {

    let cond = true;

    if (this.selected.length > 0) {

      this.selected.forEach(result => {
        const id = result.id.split('-');
        const date = id[0];
        let doctorID;
        let patientSSN;
        switch (this.type.toLowerCase()) {
          case 'clinical-sccai':
          case 'clinical-hbi':
          case 'clinical-prism':
          case 'eortc-qlq':
          case 'ibd-disk':
          case 'ipaq-sf':
          case 'miah-cd':
          case 'miah-uc':
          case 'patient-sccai':
          case 'wpai':
            doctorID = id[3];
            patientSSN = id[4];
            break;
          default:
            doctorID = id[2];
            patientSSN = id[3];
            break;
        }


        const ev = new EvaluationDTO(date, true);
        this.httpClient.post(localhost +
          BackendApi.EVALUATE_QUESTIONNAIRE + this.type.toUpperCase() + '/' + doctorID + '/' + patientSSN,
          ev, { observe: 'response', responseType: 'text' })
          .subscribe(response => {
            if (response.status === 200) {
              if (this.user.role === 'DOTTORE') {
                this.dispatching(this.type, this.patientSSN);
                setTimeout(() => {
                  this.toShow = JSON.parse(localStorage.getItem(this.type));
                  console.log(this.toShow);
                  if (this.toShow !== null) {
                    this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                    for (let i = 0; i < this.allCheck.length; i++) {
                      console.log('era: ', this.allCheck[i]);
                      this.allCheck[i] = false;
                      console.log('diventa: ', this.allCheck[i]);
                    }
                    this.dataSource = new MatTableDataSource(this.toShow);
                  }
                }, 2000);
                setTimeout(() => {
                  this.reloadChart();
                }, 1000);
              }
            } else {
              cond = false;
            }
          });
      });

      if (cond) {
        this.snackBar.open('I questionari selezionati sono stati validati!', 'Chiudi', {
          duration: 2000
        });
      } else {
        this.snackBar.open('Qualcosa è andato storto.', 'Chiudi', {
          duration: 2000
        });
      }
      this.selected.splice(0, this.selected.length);
    }
  }

  warningSelected() {

    let cond = true;

    if (this.selected.length > 0) {

      this.selected.forEach(result => {
        const id = result.id.split('-');
        const date = id[0];
        let doctorID;
        let patientSSN;
        switch (this.type.toLowerCase()) {
          case 'clinical-sccai':
          case 'clinical-hbi':
          case 'clinical-prism':
          case 'eortc-qlq':
          case 'ibd-disk':
          case 'ipaq-sf':
          case 'miah-cd':
          case 'miah-uc':
          case 'patient-sccai':
          case 'wpai':
            doctorID = id[3];
            patientSSN = id[4];
            break;
          default:
            doctorID = id[2];
            patientSSN = id[3];
            break;
        }


        const ev = new EvaluationDTO(date, false);
        this.httpClient.post(localhost +
          BackendApi.EVALUATE_QUESTIONNAIRE + this.type.toUpperCase() + '/' + doctorID + '/' + patientSSN,
          ev, { observe: 'response', responseType: 'text' })
          .subscribe(response => {
            if (response.status === 200) {
              if (this.user.role === 'DOTTORE') {
                this.dispatching(this.type, this.patientSSN);
                setTimeout(() => {
                  this.toShow = JSON.parse(localStorage.getItem(this.type));
                  console.log(this.toShow);
                  if (this.toShow !== null) {
                    this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                    for (let i = 0; i < this.allCheck.length; i++) {
                      console.log('era: ', this.allCheck[i]);
                      this.allCheck[i] = false;
                      console.log('diventa: ', this.allCheck[i]);
                    }
                    this.dataSource = new MatTableDataSource(this.toShow);
                  }
                }, 2000);
                setTimeout(() => {
                  this.reloadChart();
                }, 1000);
              }
            } else {
              cond = false;
            }
          });
      });

      if (cond) {
        this.snackBar.open('I questionari selezionati sono stati validati!', 'Chiudi', {
          duration: 2000
        });
      } else {
        this.snackBar.open('Qualcosa è andato storto.', 'Chiudi', {
          duration: 2000
        });
      }
      this.selected.splice(0, this.selected.length);
    }
  }

  printDoctorInfo(doctorID: string): string {
    const doctorInfo = JSON.parse(sessionStorage.getItem(doctorID));
    return doctorInfo !== null && doctorInfo !== undefined ? ' - Dott. ' + doctorInfo.surname + ' ' + doctorInfo.name : '';
  }

  ngOnDestroy() {
    sessionStorage.clear();
  }
}

